import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/report_form/predit/year',
    method: 'get',
    params
  })
}

